import { withAutocomplete } from './withAutocomplete';
import { getAddressSuggestions } from '../api/dadata';
import { InputBase } from '~/InputBase';

/** @typedef {import('~/api/dadata').AddressSuggestion} AddressSuggestion */

/** @type {import('~/Autocomplete').AutocompleteDataset<AddressSuggestion>} */
const dataset = {
	source: (query, cb) => {
		getAddressSuggestions(query)
			.then(cb)
			.catch(error => {
				console.error(error);
				cb([]);
			});
	},
	debounce: 250,
}

export const InputAddressAutocomplete = {
	name: 'InputAddressAutocomplete',
	extends: InputBase,
	mixins: [
		withAutocomplete([dataset]),
	],
}
